<template>
  <!-- Modal terms -->
  <div
    id="uncheck-confirmation-modal"
    aria-hidden="false"
    aria-labelledby="birthdateInformationModal"
    class="modal fade"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ this.modalHeader }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>{{ this.modalText }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-dismiss="modal" @click="confirmDelete()">
            {{ $t('Sil') }}
          </button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $t('Kapat') }}</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>
<script>
export default {
  name: 'UncheckConfirmationModal',
  props: {
    modalHeader: String,
    modalText: String,
  },
  data() {
    return {};
  },
  methods: {
    confirmDelete() {
      this.$emit('confirm-delete');
    },
  },
};
</script>
